var _g, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpvote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_2451)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 34,
    stroke: "black",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2993 34.5851L52.9456 38.1133C52.7279 38.3339 52.5102 38.7749 52.5102 38.9954V52.6672L44.2381 52.8877C43.8027 52.8877 43.3673 53.3287 43.1496 53.7697C42.9319 54.2108 43.1496 54.8723 43.585 55.0928L52.2925 61.0467V64.5749H31.3945V26.8672L57.2993 34.5851Z",
    fill: "#E6570E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 33.9231C61 33.4821 60.5646 33.041 60.1293 33.041L30.5238 24C30.0884 24 29.8707 24 29.4354 24.2205C29.2177 24.441 29 24.8821 29 25.1026V65.8974C29 66.559 29.4354 67 30.0884 67H53.5986C54.2517 67 54.6871 66.559 54.6871 65.8974V60.3846C54.6871 59.9436 54.4694 59.7231 54.2517 59.2821L47.9388 54.8718L53.5986 54.6513C54.2517 54.6513 54.6871 53.9897 54.6871 53.5487V39.6564L60.5646 35.0256C61 34.8051 61 34.3641 61 33.9231ZM52.5102 38.9949V52.6667L44.2381 52.8872C43.8027 52.8872 43.3673 53.3282 43.1497 53.7692C42.932 54.2103 43.1497 54.8718 43.585 55.0923L52.2925 61.0462V64.5744H31.3946V26.8667L57.2993 34.5846L52.9456 38.1128C52.7279 38.3333 52.5102 38.7744 52.5102 38.9949Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1839 37.8919C35.9663 37.8919 35.5309 37.6714 35.3132 37.4509C34.8778 37.0098 34.8778 36.1278 35.5309 35.6868C38.5785 33.0406 41.4084 33.0406 44.456 35.6868C44.8914 36.1278 45.1091 36.7893 44.6737 37.4509C44.2384 37.8919 43.3676 37.8919 42.9322 37.4509C40.7554 35.6868 39.2316 35.6868 37.0547 37.4509C36.837 37.6714 36.6193 37.8919 36.1839 37.8919Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.762 51.123C45.762 51.123 42.932 52.6666 42.7144 56.1948L45.762 51.123Z",
    fill: "#FFE100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7137 57.518C42.0606 57.518 41.4075 56.8565 41.6252 56.195C42.0606 52.0052 45.1082 50.2411 45.3259 50.0206C45.979 49.8001 46.632 50.0206 46.8497 50.4616C47.0674 51.1232 46.8497 51.7847 46.4143 52.0052C46.4143 52.0052 44.2375 53.3283 44.0198 56.195C43.8021 57.077 43.3667 57.518 42.7137 57.518Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_2451",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_2451"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_2451",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpvote);
export default __webpack_public_path__ + "static/media/upvote.54c40027387bb42641ab98300aa89df4.svg";
export { ForwardRef as ReactComponent };